const sharedStudentRoutes = ['/dvsa-skills', '/skills', '/mindfulness', '/achievements', '/pass-prediction', '/car-controls', '/tell-me-show-me', '/profile'];

export function isInstalledStudentApp(pathname: string): boolean {
  const installed = window.matchMedia?.('(display-mode: standalone)').matches === true ||
    (navigator as Navigator & { standalone?: boolean }).standalone === true;
  const studentRoute = pathname === '/student-home' || pathname === '/student-profile' ||
    pathname === '/student-progress-graph' || pathname.startsWith('/student/') ||
    sharedStudentRoutes.some(path => pathname === path || pathname.startsWith(`${path}/`));
  return installed && studentRoute;
}